const createPt510InitState = () => ({
  relationList: [],
  isDisplay: false,
});

const createPt510ReqModelState = () => ({});

const state = () => ({
  pt510Init: createPt510InitState(),
  pt510ReqModel: createPt510ReqModelState(),
});

const mutations = {
  RESET_PT510_STATE(currentState) {
    currentState.pt510Init = createPt510InitState();
    currentState.pt510ReqModel = createPt510ReqModelState();
  },
  SET_PT510_INIT(currentState, payload = {}) {
    currentState.pt510Init = payload || {};
  },
  MERGE_PT510_INIT(currentState, payload = {}) {
    currentState.pt510Init = Object.assign({}, currentState.pt510Init, payload);
  },
  SET_PT510_REQ_MODEL(currentState, payload = {}) {
    currentState.pt510ReqModel = payload || {};
  },
  MERGE_PT510_REQ_MODEL(currentState, payload = {}) {
    currentState.pt510ReqModel = Object.assign({}, currentState.pt510ReqModel, payload);
  },
};

const getters = {
  pt510Init: currentState => currentState.pt510Init,
  pt510ReqModel: currentState => currentState.pt510ReqModel,
};

export {
  createPt510InitState,
  createPt510ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
